import React from 'react';
import ComboBoxFormik from '../../../../../../../../common/components/form/ComboBoxFormik';
import { useFormikContext } from 'formik';
import { DateSubscriptionFormik } from '../../../../../forms/fields/DateSubscriptionFormik';
import DisplayField from '../../../../../../../../common/helpers/display-field';
import { BILLING_TYPE } from '@/types/payment.type';

type PaymentDetailsProps = {
  caucao: number;
  valueTotal: number;
  paymentOptions: { value: string; label: string }[];
  installmentOptions: { value: string; label: string }[];
  amountValue: number;
  modal?: string
};

interface MyFormState {
  paymentMethod: string;
  installmentOption: string;
  billingPeriod: string;
  paymentDescription: string;
}

const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  caucao,
  valueTotal,
  paymentOptions,
  installmentOptions,
  amountValue,
  modal
}) => {
  const formik = useFormikContext<MyFormState>();

  const totalDiscounts = caucao - valueTotal;
  const showInfo = valueTotal > caucao;

  return (
    <section className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Campos reutilizáveis com DisplayField */}
      <DisplayField label="Total das cobranças adicionadas:" value={amountValue} />
      <DisplayField label="O valor do caução do cliente é de:" value={caucao} />
      <DisplayField label="O valor total dos descontos:" value={Math.abs(valueTotal)} />

      {/* Condicional para exibir informações adicionais */}
      {!showInfo && modal === "CancelPlanModal" ? (
        <div className="col-span-full">
          <label className="text-sm text-redPrimary">
            O valor é menor que o caução
          </label>
          <DisplayField label="Valor restante do caução:" value={Math.abs(totalDiscounts)} />
          <label className="text-sm text-redPrimary">
            Não haverá cobrança e o caução será totalmente consumido.
          </label>
        </div>
      ) : (
        <DisplayField
          label="O valor total a ser cobrado da multa de cancelamento:"
          value={Math.abs(totalDiscounts)}
        />
      )}

      {/* Seção de pagamento (exibida apenas se showInfo for true) */}
      {showInfo && (
        <div className="col-span-full space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <ComboBoxFormik
              name="paymentMethod"
              label="Escolha o método de pagamento:"
              options={paymentOptions}
              required={true}
            />

            {(formik.values.paymentMethod === BILLING_TYPE.BOLETO ||
              formik.values.paymentMethod === BILLING_TYPE.CREDIT_CARD) && (
                <div className="col-span-full grid grid-cols-1 md:grid-cols-2 gap-4">
                  <ComboBoxFormik
                    name="installmentOption"
                    label="Escolha a opção de parcelamento:"
                    options={installmentOptions}
                    required={true}
                  />

                  <ComboBoxFormik
                    name="billingPeriod"
                    label="Escolha o período da cobrança:"
                    options={[
                      { value: "", label: "-" },
                      { value: "mensal", label: "Mensal" },
                      { value: "semanal", label: "Semanal" },
                    ]}
                    required={true}
                  />

                  <div className="col-span-full">
                    <DateSubscriptionFormik />
                  </div>
                </div>
              )}
          </div>

          {/* Campo de descrição do pagamento */}
          <div className="flex flex-col gap-2">
            <label htmlFor="paymentDescription" className="block text-sm font-medium text-gray-600">
              Descrição do pagamento
            </label>
            <textarea
              id="paymentDescription"
              name="paymentDescription"
              value={formik.values.paymentDescription || ''}
              onChange={(e) => formik.setFieldValue('paymentDescription', e.target.value)}
              onBlur={(e) => {
                formik.handleBlur(e);
                const val = formik.values.paymentDescription || '';
                if (val.length > 500) {
                  formik.setFieldError('paymentDescription', 'Máximo de 500 caracteres');
                } else {
                  formik.setFieldError('paymentDescription', undefined);
                }
              }}
              maxLength={500}
              style={{ resize: "none", height: "90px" }}
              className="border border-gray p-2 rounded w-full bg-[#ffffff]"
            />
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-500">
                {(formik.values.paymentDescription?.length || 0)}/500
              </div>
              {formik.touched.paymentDescription && formik.errors.paymentDescription && (
                <div className="text-redPrimary text-sm">{formik.errors.paymentDescription}</div>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PaymentDetails;